(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[23],{

/***/ "FTiw":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/play-video-893c235cf03ef18d89b6411abae8426d.svg", "placeholder": ""};

/***/ }),

/***/ "aHGA":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDI0IDMyIj4KICA8cGF0aCBpZD0iUGF0aF80MjU3IiBkYXRhLW5hbWU9IlBhdGggNDI1NyIgZD0iTTIzLjY1NSwzMC4xNjhWMTQuMTc3bDI0LDE2LjAzLTI0LDE1Ljk3MVYzMC4xNjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjMuNjU0IC0xNC4xNzgpIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo=" };

/***/ }),

/***/ "gafT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("Vvt1");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./utils/paramToResolutions.js
var paramToResolutions = __webpack_require__("vE80");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// CONCATENATED MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}

function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var react_intersection_observer_m_InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/Object(react["createElement"])(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react["Component"]);
react_intersection_observer_m_InView.displayName = 'InView';
react_intersection_observer_m_InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = Object(react["useRef"])();

  var _React$useState = Object(react["useState"])({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = Object(react["useCallback"])(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  Object(react["useEffect"])(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* harmony default export */ var react_intersection_observer_m = (react_intersection_observer_m_InView);

//# sourceMappingURL=react-intersection-observer.m.js.map

// CONCATENATED MODULE: ./components/atoms/Intersection/index.js

var __jsx = react_default.a.createElement;

 // This component mainly serves as a wrapper, which help update its childrens
// content by calling a callback `onDisplay` when it is intersected.

var Intersection_Intersection = function Intersection(_ref) {
  var onDisplay = _ref.onDisplay,
      children = _ref.children,
      className = _ref.className,
      threshold = _ref.threshold;

  var _useState = Object(react["useState"])(false),
      updated = _useState[0],
      setUpdated = _useState[1];

  var _useInView = useInView({
    threshold: threshold // trigger intersection whenever threshold is crossed in one direction or the other

  }),
      _useInView2 = Object(slicedToArray["a" /* default */])(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  Object(react["useEffect"])(function () {
    if (!updated && inView) {
      onDisplay();
      setUpdated(true);
    }
  }, [inView, onDisplay, updated]);
  return /*#__PURE__*/react_default.a.createElement("div", {
    ref: ref,
    className: className
  }, children);
};

Intersection_Intersection.defaultProps = {
  className: null,
  threshold: 0
};
/* harmony default export */ var atoms_Intersection = (Intersection_Intersection);
// EXTERNAL MODULE: ./components/shared/YoutubeVideo/play-video.svg
var play_video = __webpack_require__("FTiw");
var play_video_default = /*#__PURE__*/__webpack_require__.n(play_video);

// EXTERNAL MODULE: ./components/shared/YoutubeVideo/play-video2.svg
var play_video2 = __webpack_require__("aHGA");
var play_video2_default = /*#__PURE__*/__webpack_require__.n(play_video2);

// CONCATENATED MODULE: ./components/shared/YoutubeVideo/index.js
var YoutubeVideo_jsx = react_default.a.createElement;







var YouTube = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 22).then(__webpack_require__.bind(null, "pVhd"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("pVhd")];
    },
    modules: ['react-youtube']
  }
});

var YoutubeVideo_YoutubeVideo = function YoutubeVideo(_ref) {
  var videoId = _ref.videoId,
      smallPlayButton = _ref.smallPlayButton,
      customImage = _ref.customImage,
      className = _ref.className,
      videoTitle = _ref.videoTitle;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = Object(react["useState"])(null),
      playButtonIcon = _useState2[0],
      setPlayButtonIcon = _useState2[1];

  var _useState3 = Object(react["useState"])(null),
      thumbnail = _useState3[0],
      setThumbnail = _useState3[1];

  var _useState4 = Object(react["useState"])(null),
      ytVideo = _useState4[0],
      setYtVideo = _useState4[1];

  var handlePreviewClick = function handlePreviewClick() {
    return setIsOpen(true);
  };

  var ytOptions = {
    height: '100%',
    width: '100%'
  };

  var onPlayerReady = function onPlayerReady(e) {
    if (ytVideo) {
      setTimeout(function () {
        return e.target.playVideo();
      }, 100);
    }
  };

  var onIntersect = function onIntersect() {
    if (!ytVideo) {
      setYtVideo(videoId);
      setThumbnail(customImage);

      if (smallPlayButton) {
        setPlayButtonIcon(play_video2_default.a.url);
      } else {
        setPlayButtonIcon(play_video_default.a.url);
      }
    }
  };

  return /*#__PURE__*/react_default.a.createElement(atoms_Intersection, {
    onDisplay: onIntersect,
    className: className
  }, /*#__PURE__*/react_default.a.createElement(Video, {
    onClick: function onClick() {
      return isOpen ? null : handlePreviewClick();
    }
  }, isOpen ? /*#__PURE__*/react_default.a.createElement(YouTube, {
    videoId: ytVideo,
    opts: ytOptions,
    onReady: onPlayerReady
  }) : /*#__PURE__*/react_default.a.createElement(PreviewWrapper, null, /*#__PURE__*/react_default.a.createElement(PreviewImage, {
    videoId: videoId,
    customImage: thumbnail
  }), smallPlayButton ? /*#__PURE__*/react_default.a.createElement(SmallPlayButton, {
    alt: videoTitle,
    src: playButtonIcon
  }) : /*#__PURE__*/react_default.a.createElement(PlayButton, {
    alt: videoTitle,
    src: playButtonIcon
  }))));
};

var Video = styled_components_browser_esm["default"].div.withConfig({
  displayName: "YoutubeVideo__Video",
  componentId: "sc-8g3k2k-0"
})(["position:relative;height:100%;width:100%;iframe,div{height:100%;width:100%;}"]);
var PreviewWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "YoutubeVideo__PreviewWrapper",
  componentId: "sc-8g3k2k-1"
})(["position:relative;height:100%;width:100%;overflow:hidden;cursor:pointer;> div,> img{transition:0.6s ease-in-out;}&:hover{> div{transform:scale(1.04);}img{opacity:0.75;}}"]);
var PreviewImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "YoutubeVideo__PreviewImage",
  componentId: "sc-8g3k2k-2"
})(["height:100%;width:100%;background-image:url(", ");background-size:cover;background-position:center;"], function (_ref2) {
  var customImage = _ref2.customImage,
      videoId = _ref2.videoId;
  return customImage || "https://img.youtube.com/vi/".concat(videoId, "/maxresdefault.jpg");
});
var PlayButton = styled_components_browser_esm["default"].img.withConfig({
  displayName: "YoutubeVideo__PlayButton",
  componentId: "sc-8g3k2k-3"
})(["position:absolute;height:auto;margin:auto;top:0;left:0;bottom:0;right:0;transition:0.2s ease-in-out;", ";"], Object(paramToResolutions["a" /* default */])('width', ['90px', undefined, '130px', '150px']));
var SmallPlayButton = styled_components_browser_esm["default"].img.withConfig({
  displayName: "YoutubeVideo__SmallPlayButton",
  componentId: "sc-8g3k2k-4"
})(["position:absolute;", ";bottom:10px;right:10px;transition:0.2s ease-in-out;"], Object(paramToResolutions["a" /* default */])('width', ['24px', undefined, undefined, '37px']));
YoutubeVideo_YoutubeVideo.defaultProps = {
  videoId: null,
  smallPlayButton: false,
  customImage: null,
  className: null,
  videoTitle: null
};
/* harmony default export */ var shared_YoutubeVideo = __webpack_exports__["default"] = (YoutubeVideo_YoutubeVideo);

/***/ })

}]);